module.exports = __webpack_public_path__ + "static/media/camping.40132805.jpg";